import { Component, Input, OnInit } from "@angular/core";
import { ScaffoldDialogRef } from "@app/framework/dialog/scaffold-dialog.service";
import { IntegrationService } from "@services/integration.service";
import { tap } from "rxjs/operators";
import { UserService } from "@services/user.service";
import { ActivatedRoute, Router } from "@angular/router";
import { EnvironmentService } from "@services/environment.service";
import { NotificationsService } from "@services/notifications.service";

@Component({
  selector: "app-integration-status-modal",
  templateUrl: "./integration-status-modal.component.html",
  styleUrls: ["./integration-status-modal.component.scss"],
})
export class IntegrationStatusModalComponent implements OnInit {
  @Input()
  set integration(value: any) {
    this._integration = value;
    this.logo = this.getLogo(value);
  }
  get integration(): any {
    return this._integration;
  }
  private _integration: any;
  logo: string;
  public integrations$;
  public statusItem;
  roleData:any;
  constructor(
    private dialogRef: ScaffoldDialogRef,
    private integrationService: IntegrationService,
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private environmentService: EnvironmentService,
    private notifications: NotificationsService
  ) {}

  ngOnInit(): void {
    this.userService.getRoleDetails().subscribe((data) => {
      this.roleData = data;
    });
    this.integrations$ = this.integrationService
      .getIntegration$(this?.["data"]?.integration?.id)
      .pipe(
        tap((integration: any) => {
          // if (state?.isLoading) return;
          if (!integration) {
            this.dialogRef.close();
          }
          this.integration = integration;
          this.statusItem = this.integrationService.getStatusRequirements(this.integration);
        })
      );
  }

  getLogo(integration) {
    let type;
    if(integration.integration_type === 'dwh'){
      type = 'warehouse'
    }else if(integration.integration_type === 'live_event'){
      type = 'live_event'
    }else{
      type = integration.json_data[integration.integration_type + '_type'];
    }
    return `https://k16-hosted-lib.s3.us-east-2.amazonaws.com/${type}.png`;
  }

  getPlaceholderLogo(){
    return "https://k16-hosted-lib.s3.us-east-2.amazonaws.com/placeholder.png";
  }

  validateStatus(): { status: string, title: string, message: string }[] {

    return !Array.isArray(this.statusItem)?[]: this.statusItem.map(status => {
      if (status.key) {
        let result = this.integration?.json_data?.[status.key] || { status: 'error', message: 'Check has not been run' }
        if(!result.message){
          result.message = status.messages[result.status];
        }
        return { ...result, title: status.title }
      } else if (status.dataKeys) {
        let found = status.dataKeys.every(key => this.integration?.json_data?.[key])
        let state = found ? 'ok' : 'error'
        return { status: state, title: status.title, message: status.messages[state] }
      }
    });
  }
  handleEditClick($event) {
    if (this.roleData?.manage_integrations) {
      this.environmentService.getInstanceDetails().subscribe(environment => {
        if (environment.scaffoldType === 'archivev2') {
          this.router.navigate(['imports/edit-integration/' + $event.id]).then(() => {
            this.dialogRef.close();
          });
        } else {
          this.router.navigate(['admin/integrations/edit/' + $event.id]).then(() => {
            this.dialogRef.close();
          });
        }

      });
    }
  }
  close() {
    this.dialogRef.close();
  }
  handleRefreshClick() {
    this.integrationService
      .refreshIntegration$(this.integration)
      .subscribe((response) => {
        let hasError =
          response.error || response.errorMessage || !response?.[0]?.id;

        if (hasError) {
          this.notifications.popNotification(
            "",
            "Error Refreshing Integration"
          );
        } else {
          this.notifications.popNotification(
            "",
            "Initiated Integration Refresh"
          );
        }
      });
  }
}
